import React from "react";
import {Spin} from "antd";
import '../../styles/ui/Uicss/loader.css'

const CircularProgress = () =>
    // <Spin className={'gx-loader-container'} tip={"Loading..."}/>;
    <div class="loader"></div>
export default CircularProgress;
